type Primitive = string | number | boolean | null | undefined;

type FlattenObject = (
  source: unknown,
  prefix?: string
) => Record<string, Primitive>;

/**
 * Flattens object so that it can be properly consumed by PostHog.
 *
 * @param event - Source object
 * @param prefix - Prefix for keys
 * @returns Flattened object
 */
const flattenObject: FlattenObject = (source, prefix = "") => {
  const result: Record<string, Primitive> = {};

  if (typeof source !== "object" || source === null) {
    result[prefix] = source as Primitive;

    return result;
  }

  for (const key in source as Record<string, unknown>) {
    if (!Object.prototype.hasOwnProperty.call(source, key)) {
      continue;
    }

    const value = (source as Record<string, unknown>)[key];

    const snakeKey = key
      .replace(/([A-Z]+)([A-Z][a-z])/g, "$1_$2")
      .replace(/([a-z\d])([A-Z])/g, "$1_$2")
      .toLowerCase();

    const newKey = prefix ? `${prefix}_${snakeKey}` : snakeKey;

    if (typeof value === "object" && value !== null) {
      if (Array.isArray(value)) {
        value.forEach((item, index) => {
          const indexedKey = `${newKey}_${index}`;
          result[indexedKey] = item as Primitive;
        });
      } else {
        Object.assign(result, flattenObject(value, newKey));
      }
    } else {
      result[newKey] = value as Primitive;
    }
  }

  return result;
};

export { flattenObject };
